export type IManagePickerFile = {
  id: string;
  name: string;
  extension?: string;
};

/** Match folder-sync naming: iManage profile `name` plus `extension`. */
export function joinIManageDocumentFilename(name?: string, extension?: string): string {
  const trimmedName = (name ?? '').trim() || 'unknown';
  const trimmedExtension = (extension ?? '').trim();
  if (!trimmedExtension) {
    return trimmedName;
  }

  const suffix = trimmedExtension.startsWith('.') ? trimmedExtension : `.${trimmedExtension}`;
  if (trimmedName.toLowerCase().endsWith(suffix.toLowerCase())) {
    return trimmedName;
  }
  return `${trimmedName}${suffix}`;
}

function filenameHasExtension(filename: string): boolean {
  const lastDot = filename.lastIndexOf('.');
  return lastDot > 0 && lastDot < filename.length - 1;
}

/**
 * Filename for a picker download uploaded as a local File.
 * Prefer the iManage profile (already fetched for the dialog). Fall back to the
 * download Content-Disposition name only when it already has a real suffix.
 */
export function imanagePickerUploadFilename(
  metadata: IManagePickerFile | undefined,
  downloadedFilename?: string | null,
): string {
  const fromProfile = metadata
    ? joinIManageDocumentFilename(metadata.name, metadata.extension)
    : '';

  if (filenameHasExtension(fromProfile)) {
    return fromProfile;
  }

  const downloaded = (downloadedFilename ?? '').trim();
  if (filenameHasExtension(downloaded)) {
    return downloaded;
  }

  if (fromProfile) {
    return fromProfile;
  }

  return downloaded || `document_${metadata?.id ?? 'unknown'}`;
}
